import React, {useContext, useEffect, useState} from "react";
import {reloadScreen} from "../../util/utils";
import {convertTimestampToDate} from "../../util/time";
import * as api from "../../api/skyduck";
import Collapse from "react-bootstrap/Collapse";
import Container from "react-bootstrap/Container";
import getJump3DLink from "../../api/skyduck";
import {Button} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {CardWrapper} from "../common/card";
import Modal from "react-bootstrap/Modal";
import {JumpForm} from "../form/jump-form";
import {JumpFormReadOnly} from "../form/jump-form";
import {UnitsContext} from "../../index";
import {Icon} from "../common/jump";
import Fade from "react-bootstrap/Fade";
import {FormsHolder, isFormsReadyToUpload, mapFormsForAPI} from "../form/form-holder";
import * as ReactGA from "react-ga";
import {Profile} from "./profile";

function Show3DButton(props) {
    const units = useContext(UnitsContext).units;
    return (<>
        {
            props.is3DAvailable
                ? <>
                    <a role="button"
                       target="_blank" rel="noopener noreferrer"
                       className="btn btn-sm btn-outline-primary my-2 mr-2"
                       href={getJump3DLink(props.jumpID, units)}>Show 3D</a>
                </>
                : null
        }
    </>)
}

function JumpTitle(props) {
    return (
        <h6 className="mb-0">{props.jumpNumber} {props.title ? <span> • {props.title}</span> : null}</h6>
    )
}

class JumpViewAndEditForm extends FormsHolder {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <>
                <Fade in={this.props.edit}>
                    <Row className="mt-3">
                        {this.props.edit
                            ? <JumpForm {...this.state.jumps[0]}
                                index="0"
                                updateDictionaries={this.updateDictionaries}
                                dictionaries={this.state.dictionaries}
                                handleFormChange={this.changeForm}
                            />
                            : null
                        }
                    </Row>
                </Fade>
                <Fade in={!this.props.edit}>
                    <Row className="mt-3">
                        {this.props.edit
                            ? null
                            : <JumpFormReadOnly {...this.state.jumps[1]} dictionaries={this.state.dictionaries}/>
                        }
                    </Row>
                </Fade>

                <Row className="mt-3 justify-content-between">
                    <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto">
                        <EditJumpButton {...this} edit={this.props.edit} setEdit={this.props.setEdit} />
                    </Col>
                    <Col xs="12" sm="12" md="auto" lg="auto" xl="auto" className="small-top-margin">
                        <DeleteJumpButton {...this.props}/>
                    </Col>
                </Row>
            </>
        )
    }
}

function EditJumpButton(props) {
    return (
        <>
            {props.edit
                ? <>
                    <ConfirmEditJumpButton {...props}/>
                    <Button className="mr-2" variant="outline-primary" size="sm"
                    onClick={() => {
                        props.setEdit(false);
                        props.cancelEditedJump();
                    }}
                    >Cancel</Button>
                </>
                : <>
                    <Button className="mr-2" variant="outline-primary" size="sm"
                              onClick={() => {props.setEdit(true)}}
                    >Edit jump</Button>
                </>
            }

        </>
    );
}

function ConfirmEditJumpButton(props) {
    const units = useContext(UnitsContext).units;
    const [isLoading, setLoading] = useState(false);

    const EDITING = true;

    useEffect(() => {
        if (isLoading) {
            if (isFormsReadyToUpload(props.state.jumps)) {
                api.uploadJumps(mapFormsForAPI([props.state.jumps[0]]), units, EDITING).then(() => {
                    setLoading(false);
                    props.setEdit(false);

                    ReactGA.event({
                        category: 'User',
                        action: 'Edited jump'
                    });

                    // TODO You should also update header of jump here...
                    //props.updateJumpAfterUpload();
                    reloadScreen();
                })
            } else {
                props.validateForms();
                setLoading(false);
            }
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    return (
        <Button
            className="mr-2"
            variant="outline-primary"
            size="sm"
            disabled={isLoading}
            onClick={!isLoading ? handleClick : null}
        >
            {isLoading ? 'Editing...' : 'Confirm'}
        </Button>
    );
}

function JumpInGroup(props) {
    const [open, setOpen] = useState(false);
    const [edit, setEdit] = useState(false);

    return (
        <>
            <hr/>
            <Row className="justify-content-between">
                <Col className="my-auto">
                    <a className="align-items-center"
                       onClick={() => setOpen(!open)}
                       aria-controls="collapsed-details" aria-expanded={open}>
                        <Container>
                            <Row>
                                <JumpTitle {...props}/>
                            </Row>
                            {props.iconIDs.length > 0 && !edit
                                ? <Row className="icon-negative-margin mt-3">
                                    {
                                        props.iconIDs.map((icon, index) => (
                                            <Icon name={icon.name} url={icon.url} key={index}/>
                                        ))
                                    }
                                </Row>
                                : null
                            }
                        </Container>
                    </a>
                </Col>
                <Col xs="12" sm="12" md="auto" lg="auto" xl="auto" className="my-auto small-top-margin">
                    <Show3DButton {...props}/>
                    <Button variant="outline-primary" size="sm" onClick={() => setOpen(!open)}>Show details</Button>
                </Col>
            </Row>
            <Collapse in={open}>
                <div id="collapsed-details">
                    <JumpViewAndEditForm {...props} oneJumpMode={true} edit={edit} setEdit={setEdit}/>
                </div>
            </Collapse>
        </>
    )
}

function DeleteJumpButton(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Button variant="outline-danger" size="sm" onClick={handleShow}>
                Delete jump
            </Button>
            <Modal show={show}
                   onHide={handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete jump
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <p>You are about to delete jump:</p>
                        <h6>{props.jumpNumber} {props.title ? <span> • {props.title}</span> : null}</h6>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <ConfirmDeleteJumpButton {...props} handleClose={handleClose}/>
                </Modal.Footer>
            </Modal>
        </>
    );
}

function ConfirmDeleteJumpButton(props) {
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            api.deleteJump(props.jumpID).then(() => {
                props.handleClose();
                ReactGA.event({
                    category: 'User',
                    action: 'Deleted jump'
                });
                reloadScreen();
            });
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    return (
        <Button
            variant="outline-danger"
            disabled={isLoading}
            onClick={!isLoading ? handleClick : null}
        >
            {isLoading ? 'Deleting...' : 'Confirm'}
        </Button>
    );
}

function JumpGroup(props) {
    let firstJumpOfDay = props.jumps[0];

    let dropzones = props.jumps.map(jump => jump.dropzone);
    dropzones = Array.from(new Set(dropzones).values()).join(' • ');

    return (
        <CardWrapper>
            <h5 className="mt-1 mb-1">{convertTimestampToDate(firstJumpOfDay.date)}</h5>
            <p className="skyduck-color">{dropzones}</p>
            {
                props.jumps.map((jump, index) => (
                    <JumpInGroup {...jump} key={index}/>
                ))
            }
        </CardWrapper>
    )
}

export function JumpsTable(props) {
    return (
        <>
            <div className="mb-3">
                <Profile {...props}/>
            </div>

            {props.state.jumps.length > 0
                ? <p>Click on jump to see details.</p>
                : <p>Your jumps would appear here.</p>
            }

            {
                props.state.jumps.map((jumps, index) => (
                    <div className="mb-3" key={index}>
                        <JumpGroup jumps={jumps}/>
                    </div>
                ))
            }
        </>
    );
}